import { isDevEnv } from '@config/environment'
import { useEffect } from 'react'

export const APP_NAME = isDevEnv() ? 'Bananorama' : 'Panorama'

/**
 * Titles the tab `{pageName} | Panorama` while mounted. A layout and the page it renders must not
 * both call this: their effects would restore each other's title.
 */
export const usePageTitle = (pageName: string): void => {
  useEffect(() => {
    const previousTitle = document.title
    document.title = `${pageName} | ${APP_NAME}`

    return () => {
      document.title = previousTitle
    }
  }, [pageName])
}
